import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  border: none;\n  background: none;\n  padding: 0px;\n  text-decoration: underline;\n  text-transform: uppercase;\n  color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
export var TextButton = styled(function(_param) /*#__PURE__*/ {
    var children = _param.children, rest = _object_without_properties(_param, [
        "children"
    ]);
    return _jsx("button", _object_spread_props(_object_spread({
        type: "button"
    }, rest), {
        children: /*#__PURE__*/ _jsx("span", {
            children: children
        })
    }));
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.text.body.color;
});
